/* BG COM 04/10/2026 (vitesse r3) : sorti de sections/bgcom-pdp-polish.liquid (bloc <script> en ligne, 0 Liquid).
   04/10/2026 (vitesse r4, jury CWV) : chargé en defer (plus de blocage de l'analyse ni de préchargement). En attendant, la garde CSS
   « data-bgp-wait » (posée par la section, règles dans assets/bgcom-pdp-polish.css) donne au bloc d'achat la géométrie de la version finie ;
   le premier passage la retire dans la même tâche que data-bgcom-polished (finally : retirée même en cas d'erreur). */
(function(){
  var SVG={
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
    user:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>'
  };
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
  /* read the theme SKU via textContent so it still resolves once we display:none it */
  function skuRef(){var e=document.querySelector('.product__sku');return e?(e.textContent||'').replace(/^r[ée]f\s*\.?\s*:?\s*/i,'').trim():'';}

  /* The summary mirrors the theme's stock pill of the MAIN product (the product-info that holds the price, never a
     quick view copy), read with textContent. innerText depends on rendering: once polished the pill is display:none,
     and on phones the product section is content-visibility:auto, so a load in a background tab or hidden window
     returned "" and the summary fell back to "En stock · 48-72h" (made-to-order and "Plus que 4" lost, seen at 375 px). */
  function scopeOf(el){ return (el && el.closest && el.closest('product-info, .product__info')) || document; }
  function pillOf(scope){ return scope.querySelector('.bgcom-stock-pill'); }
  function pillText(scope){ var p=pillOf(scope); return p ? (p.textContent||'').replace(/\s+/g,' ').trim() : ''; }

  /* "Sur commande · livraison 48-72 h" becomes "Sur commande / Livraison 48-72 h", never a blanket "En stock".
     These are door-to-door delivery times, everything included (user, 02/10/2026): always say "Livraison", never "Expédition".
     Rule (user, 03/10/2026 night, final): in stock = 24-48 h, made-to-order (stock <= 0, still sellable) = 48-72 h,
     colour-made aerosol = 24-48 h, generic = 24-72 h, never "5-10 j". Items with their own rule keep it (the pill's delay wins). */
  function stockInfo(pill, scope){
    var state=/sur commande|pr[ée]commande|r[ée]appro/i.test(pill)?'order':(/rupture|[ée]puis[ée]|indisponible/i.test(pill)?'out':'in');
    var deliv, lowTxt='';
    /* 12/10/2026 : délai propre du produit (data-bgcom-dl posé par sections/bgcom-pdp-polish ; crochets = 3-5 jours, user 11/10/2026) :
       il gagne en stock comme sur commande, même sans pastille (variante non suivie en stock) ou avec « Plus que N en stock » */
    var own=document.body.getAttribute('data-bgcom-dl');
    if(state==='order'){ var dm=pill.match(/livraison\s*(?:sous\s*)?([0-9][0-9\s\-–àa]*\s*(?:h\b|j\w*))/i); deliv=dm?dm[1].replace(/\s+/g,' ').replace(/(\d)j/,'$1 j').trim():'48-72 h'; }
    else {
      var low=pill.match(/plus que\s*(\d+)\s*en stock/i);           /* real low-stock count from the theme */
      if(low) lowTxt='Plus que '+low[1]+' en stock';
      /* in stock (or stock not tracked): 24-48 h (user 03/10/2026 night); the pill's own delay wins when it has one */
      var dl=pill.match(/livraison\s*(?:sous\s*|en\s*)?([0-9][0-9\s\-–àa]*\s*(?:h\b|j\w*))/i);
      deliv=dl ? dl[1].replace(/\s+/g,' ').replace(/(\d)j/,'$1 j').trim() : '24-48 h';
    }
    if(own) deliv=own;
    var t=(state==='in'?(lowTxt||'En stock'):(state==='order'?'Sur commande':'En rupture'));
    var lab='Livraison';
    /* rupture (03/10) : pas de délai de livraison à promettre, le panneau snippets/bgcom-rupture propose l'alerte e-mail */
    if(state==='out'){ lab='Réassort'; deliv='en cours'; }
    return {state:state, t:t, lab:lab, deliv:deliv, key:state+'|'+t+'|'+deliv};
  }

  function itemHTML(ic, icCls, t, s){
    return '<span class="'+icCls+'" aria-hidden="true">'+SVG[ic]+'</span>'
      +'<span class="bgcom-summary__tx"><span class="bgcom-summary__t">'+t+'</span>'+(s?'<span class="bgcom-summary__s">'+s+'</span>':'')+'</span>';
  }
  /* repaint the stock + delivery items only when the pill's meaning changed (variant change), so the sonar never replays for nothing */
  function paintSummary(ul, info){
    if(ul.getAttribute('data-stock')===info.key) return;
    var st=ul.querySelector('.bgcom-summary__item--stock'), dv=ul.querySelector('.bgcom-summary__item--deliv');
    if(!st || !dv) return;
    ul.setAttribute('data-stock', info.key);
    st.innerHTML=itemHTML('check', 'bgcom-summary__ic bgcom-summary__ic--stock is-'+info.state, info.t, '');
    dv.innerHTML=itemHTML('truck', 'bgcom-summary__ic', info.lab, esc(info.deliv));
  }

  /* the "Livraison & garanties" accordion promises fast shipping to everyone: on made-to-order it says what the pill
     says instead, and gets its own words back if the chosen variant is in stock again */
  function syncAccordion(scope, info){
    var lis=scope.querySelectorAll('.bgcom-acc__list li');
    if(!lis.length && scope!==document) lis=document.querySelectorAll('.bgcom-acc__list li');
    [].forEach.call(lis, function(li){
      if(li._bgcomOrig===undefined){
        var b=li.querySelector('strong');
        if(!(b && /(exp[ée]dition|livraison) rapide/i.test(b.textContent))) return;
        li._bgcomOrig=li.innerHTML; li._bgcomKey='orig';
      }
      var key=info.state==='order' ? 'order|'+info.deliv : (info.state==='out' ? 'out' : 'orig');
      if(li._bgcomKey===key) return;
      li._bgcomKey=key;
      li.innerHTML= info.state==='order'
        ? '<strong>Livraison sur commande</strong> : '+(info.deliv==='sur devis'?'délai sur devis.':'sous '+esc(info.deliv)+' en France métropolitaine.')
        : (info.state==='out' ? '<strong>Réassort en cours</strong> : laissez votre e-mail, nous vous prévenons dès le retour en stock.' : li._bgcomOrig);
    });
  }

  function buildSummary(){
    var price=document.querySelector('.bgcom-product-header__price')
           || document.querySelector('.bgcom-product-price-stack')
           || document.querySelector('.product__price');
    var ul=document.querySelector('.bgcom-summary');
    if(!price && !ul) return false;
    var scope=scopeOf(price||ul);
    var info=stockInfo(pillText(scope), scope);
    if(!ul){
      /* 04/10/2026 (jury r2, axe « list ») : un <div> (ses enfants sont des <div> et un <a>, pas des <li>) ; le CSS ne vise que la classe */
      ul=document.createElement('div'); ul.className='bgcom-summary';
      ['stock','deliv'].forEach(function(k){ var el=document.createElement('div'); el.className='bgcom-summary__item bgcom-summary__item--'+k; ul.appendChild(el); });
      // 3rd item = pro, filled by syncPro() with the guest OR connected (Espace Pro) state
      var pro=document.createElement('a'); pro.className='bgcom-summary__item bgcom-summary__pro';
      ul.appendChild(pro);
      paintSummary(ul, info);
      price.insertAdjacentElement('afterend', ul);
      syncPro();
    } else {
      paintSummary(ul, info);
    }
    syncAccordion(scope, info);
    return true;
  }

  /* variant change: the theme swaps the price, SKU and inventory blocks but not the stock pill (it keeps the first
     variant's state). Take the pill of the chosen variant from the section HTML the theme just fetched, put it in
     place of the old one, then repaint the summary. Main product only (the one that carries the summary). */
  var _vsub=false;
  function subscribeVariant(){
    if(_vsub) return;
    var ps=window.theme && window.theme.pubsub;
    if(!ps || typeof ps.subscribe!=='function' || !ps.PUB_SUB_EVENTS || !ps.PUB_SUB_EVENTS.variantChange) return;
    _vsub=true;
    ps.subscribe(ps.PUB_SUB_EVENTS.variantChange, function(ev){
      try{
        var d=ev && ev.data; if(!d || !d.parsedHTML || !d.parsedHTML.getElementById) return;
        var id='ProductInfo-'+d.sectionId+'-'+d.productId;
        var live=document.getElementById(id), fresh=d.parsedHTML.getElementById(id);
        if(!live || !fresh || !live.querySelector('.bgcom-summary')) return;
        var lp=pillOf(live), fp=pillOf(fresh);
        if(lp && fp){
          if(lp.className!==fp.className) lp.className=fp.className;
          if(lp.innerHTML!==fp.innerHTML) lp.innerHTML=fp.innerHTML;
        } else if(lp){
          lp.parentNode.removeChild(lp);
        } else if(fp){
          var node=document.importNode(fp, true), trust=live.querySelector('.bgcom-price-trust'), hdr=live.querySelector('.bgcom-product-header');
          if(trust) trust.parentNode.insertBefore(node, trust);
          else if(hdr) hdr.insertAdjacentElement('afterend', node);
        }
        buildSummary();
      }catch(e){}
    });
  }

  function syncPro(){
    var pro=document.querySelector('.bgcom-summary__pro'); if(!pro) return;
    var connected=!!document.querySelector('.bgpro-procta--in');
    var want=connected?'in':'out';
    if(pro.dataset.state===want) return;
    pro.dataset.state=want;
    pro.setAttribute('href', connected?'/account':'/pages/compte-pro');
    var icCls='bgcom-summary__ic'+(connected?' bgcom-summary__ic--ok':'');
    var t=connected?'Espace Pro':'Tarifs pro';
    var s=connected?'Mon compte →':'Connectez-vous';
    pro.innerHTML='<span class="'+icCls+'" aria-hidden="true">'+SVG.user+'</span>'
      +'<span class="bgcom-summary__tx"><span class="bgcom-summary__t">'+t+'</span>'
      +'<span class="bgcom-summary__s">'+s+'</span></span>';
  }

  /* origin: is it stated on the page (product content, an image alt)? textContent of the page content, scripts and styles
     skipped: no forced layout (document.body.innerText cost 170-360 ms of forced reflow per pass on the aerosol and the
     KS caps, 04/10/2026). Read once, when the document is fully parsed. */
  /* 04/10/2026 (vitesse r3, jury) : seulement le contenu de CE produit. Les blocs d'autres produits (pack « Complétez » et sa pop-up,
     cartes, Produits similaires, aperçu rapide, toute pop-up <dialog>) sont sautés avec tout leur contenu, ainsi que leurs images :
     un « Fabriqué en France » d'un accessoire ne met plus le drapeau sur la fiche. */
  var ORIG_SKIP='script,style,noscript,template,dialog,product-recommendations,[data-bgb],.bgb,.bgb-dlg,.product-card,.card-grid,.bgcom-qv,.bgcom-quick-view';
  var ORIG_RE=/fabriqu[ée]\s+en\s+france|made\s+in\s+france/i;
  var _orig=null;
  function originStated(){
    if(_orig!==null) return _orig;
    if(document.readyState==='loading') return false;
    var root=document.getElementById('MainContent')||document.body;
    var imgs=root.querySelectorAll('img[alt]'), alts='';
    for(var i=0;i<imgs.length;i++){ var a=imgs[i].alt||''; if(a && ORIG_RE.test(a) && !imgs[i].closest(ORIG_SKIP)) alts+=' '+a; }
    if(alts){ _orig=true; return _orig; }
    /* fast path (almost every product): the mention is nowhere in the page content, not even in a skipped block */
    if(!ORIG_RE.test(root.textContent||'')){ _orig=false; return _orig; }
    /* the mention is somewhere: read only the text outside the skipped blocks (one query for the blocks, then a walk) */
    var skip=new Set(root.querySelectorAll(ORIG_SKIP)), s='';
    var w=document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT, {acceptNode:function(n){
      if(n.nodeType===3) return NodeFilter.FILTER_ACCEPT;
      return skip.has(n) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP; }});
    while(w.nextNode()) s+=w.currentNode.nodeValue;
    _orig=ORIG_RE.test(s);
    return _orig;
  }
  var ORIGIN_HTML='Fabriqué en France <span class="bgcom-meta__flag">🇫🇷</span>';
  /* the meta line is built on the first pass (buy box already parsed); the origin is added once the page is complete */
  function addOrigin(meta){
    if(meta._bgO || document.readyState==='loading') return;
    meta._bgO=true;
    if(!originStated() || meta.querySelector('.bgcom-meta__flag')) return;
    meta.insertAdjacentHTML('beforeend','<span class="bgcom-meta__sep">·</span>'+ORIGIN_HTML);
  }

  function buildMeta(){
    var have=document.querySelector('.bgcom-meta');
    if(have){ addOrigin(have); return; }
    var title=document.querySelector('.bgcom-product-header__title')
           || document.querySelector('.product__title')
           || document.querySelector('h1');
    if(!title) return;
    var parts=[];
    var ref=skuRef();
    if(ref) parts.push('<span class="bgcom-meta__ref">Réf. '+esc(ref)+'</span>');
    var ttl=(document.querySelector('h1')||title).textContent||'';
    var m=ttl.match(/(\d[\d.,]*)\s?(ml|cl|kg|l|g)\b/i);
    if(m) parts.push(esc(m[1]+' '+m[2].toLowerCase()));
    // origin: honest — only if the product/page actually states it (title, page content, or an image alt)
    var full=document.readyState!=='loading';
    if((full && originStated()) || /fabriqu[ée]\s+en\s+france|made\s+in\s+france/i.test(ttl)) parts.push(ORIGIN_HTML);
    if(!parts.length) return;
    var div=document.createElement('div'); div.className='bgcom-meta';
    div.innerHTML=parts.join('<span class="bgcom-meta__sep">·</span>');
    if(full) div._bgO=true;
    title.insertAdjacentElement('afterend', div);
  }

  // keep the meta Réf in sync with the selected variant (the theme's .product__sku updates on change)
  function syncMetaRef(){
    var el=document.querySelector('.bgcom-meta__ref'); if(!el) return;
    var ref=skuRef();
    if(!ref) return;
    var want='Réf. '+ref;
    if(el.textContent!==want) el.textContent=want;
  }

  var _obs=false;
  function observeVariant(){
    if(_obs) return;
    var host=document.querySelector('product-info')||document.querySelector('.product__info-wrapper')||document.querySelector('.product');
    if(!host) return;
    _obs=true;
    var t;
    new MutationObserver(function(){ clearTimeout(t); t=setTimeout(run,120); }).observe(host,{childList:true,subtree:true,characterData:true});
    document.addEventListener('change',function(e){ if(e.target&&e.target.name){ setTimeout(run,150); } }, true);
  }

  // the product description sat orphaned under the CTA with no section cue (unlike FICHES &
  // DOCUMENTS below it). Give it an eyebrow that matches the buy-box labels so it reads as a
  // real section. Only when the description actually has content.
  function addDescLabel(){
    var desc=document.querySelector('.bgcom-desc'); if(!desc) return;
    if(desc.dataset.bgcomLabelled) return;
    if((desc.textContent||'').replace(/\s+/g,' ').trim().length<20) return;
    desc.dataset.bgcomLabelled='1';
    var lab=document.createElement('span'); lab.className='bgcom-desc-eyebrow'; lab.textContent='Description';
    desc.parentNode.insertBefore(lab, desc);
  }

  function hideBack(){
    if(hideBack._done) return;
    /* textContent (innerText forced a layout of the whole page on every pass) */
    var bs=document.querySelectorAll('button'), b=null;
    for(var i=0;i<bs.length;i++){ if(/^\s*retour\s*$/i.test(bs[i].textContent||'')){ b=bs[i]; break; } }
    if(b){ (b.closest('div')||b).style.display='none'; hideBack._done=true; }
  }

  // "Autre" on a radio group reveals a free-text input; the checked radio then submits "Autre : <texte>" ("Autre" when
  // left empty), same format as the pro cart drawer (bgpro-sug.js, 13/10), under the unchanged property name ASPECT|BRILLANCE
  // -> the n8n bon de livraison + the order pick it up as-is. The input sits inside the field: Fine Texture (hide_when) and an
  // Interpon colour hide and disable it with the field.
  var AUTRE_PH={ ASPECT:'Pr\u00e9cisez l\u2019aspect (ex. martel\u00e9)', BRILLANCE:'Pr\u00e9cisez la brillance (ex. 50\u00a0%)' };
  function wireAutre(){
    document.querySelectorAll('.bgcom-product-configurator__radiogroup').forEach(function(group){
      if(group.dataset.bgcomAutre) return;
      var radios=[].slice.call(group.querySelectorAll('input[type="radio"]'));
      var autre=radios.filter(function(r){ return /^\s*autre\s*$/i.test(r.dataset.bgcomOrig||r.value||''); })[0];
      if(!autre) return;
      if(!autre.dataset.bgcomOrig) autre.dataset.bgcomOrig=autre.value; // e.g. "Autre"
      group.dataset.bgcomAutre='1';
      var fld=group.closest('[data-bgcom-cfg-field]'), ph=(fld && AUTRE_PH[fld.getAttribute('data-bgcom-cfg-field')])||'Pr\u00e9cisez votre choix\u2026';
      var wrap=document.createElement('div');
      wrap.className='bgcom-autre-wrap'; wrap.style.display='none';
      var input=document.createElement('input');
      input.type='text'; input.className='bgcom-autre-input'; input.setAttribute('autocomplete','off'); input.maxLength=80;
      input.setAttribute('placeholder',ph);
      input.setAttribute('aria-label',ph);
      wrap.appendChild(input);
      group.insertAdjacentElement('afterend', wrap);
      function sync(){ var t=input.value.trim(); autre.value=t ? autre.dataset.bgcomOrig+' : '+t : autre.dataset.bgcomOrig; }
      function refresh(e){
        var was=wrap.style.display!=='none';
        wrap.style.display= autre.checked ? 'block' : 'none';
        sync();
        if(autre.checked && !was && e && e.isTrusted) input.focus();   // a click on « Autre » goes straight to typing (the colour script also fires change, untrusted)
      }
      radios.forEach(function(r){ r.addEventListener('change', refresh); });
      input.addEventListener('input', sync);
      refresh();
    });
  }

  function shortenPills(){
    // configurator radios display long option text -> show a short label, keep the full value on the input
    document.querySelectorAll('.bgcom-product-configurator__radio').forEach(function(lbl){
      var span=lbl.querySelector('span');
      if(!span || span.dataset.bgcomShort) return;
      var full=span.textContent.trim();
      var short=full.split('(')[0].trim();
      var pm=full.match(/\((\d+)\s*%/); // keep the brillance percentage: "Brillant 85%"
      if(pm) short=(short+' '+pm[1]+'%').trim();
      if(short && short!==full){ span.textContent=short; }
      span.dataset.bgcomShort='1';
    });
  }

  // The colour autocomplete (bgcom-ral-classic-datalist) reopens its list after a pick:
  // choose() dispatches 'input', whose handler re-renders the sole exact match. We close
  // it the moment it reopens showing only the chosen value — value/change dispatch, the
  // Interpon note and the swatch (all fired by choose/the handler) stay intact.
  function patchAutocomplete(){
    document.querySelectorAll('.bgcom-ac-list').forEach(function(list){
      if(list.dataset.bgcomAcPatched) return;
      var wrap=list.closest('.bgcom-ac-wrap'); if(!wrap) return;
      var input=wrap.querySelector('.bgcom-product-configurator__input--ral')||wrap.querySelector('input');
      list.dataset.bgcomAcPatched='1';
      new MutationObserver(function(){
        if(!list.classList.contains('is-open')) return;
        var items=list.querySelectorAll('.bgcom-ac-item');
        if(input && items.length===1 && items[0].textContent.trim()===(input.value||'').trim()){
          list.classList.remove('is-open'); list.innerHTML='';
        }
      }).observe(list,{childList:true, attributes:true, attributeFilter:['class']});
      /* keyboard a11y: the datalist's highlight() only toggles .is-active on the rows. Expose the list as a
         combobox popup and point aria-activedescendant at the active row, so a screen reader announces the RAL
         that Enter will pick. Rows get stable ids; attributes only, nothing in the list is re-rendered. */
      if(input){
        if(!list.id) list.id='bgcom-ac-list-'+(patchAutocomplete._n=(patchAutocomplete._n||0)+1);
        input.setAttribute('role','combobox');
        input.setAttribute('aria-autocomplete','list');
        input.setAttribute('aria-controls',list.id);
        var ariaSync=function(){
          var open=list.classList.contains('is-open') && list.children.length>0, act=null;
          [].forEach.call(list.children,function(li,i){
            if(li.id!==list.id+'-o'+i) li.id=list.id+'-o'+i;
            if(li.classList.contains('is-active')) act=li;
          });
          input.setAttribute('aria-expanded', open?'true':'false');
          if(open && act) input.setAttribute('aria-activedescendant',act.id); else input.removeAttribute('aria-activedescendant');
        };
        new MutationObserver(ariaSync).observe(list,{childList:true, subtree:true, attributes:true, attributeFilter:['class']});
        ariaSync();
      }
    });
  }

  /* 04/10 r4.3 (vitesse) : garde et état « fini » en attributs data-* sur le <body> et non en classes : le thème (theme.css,
     .rte ... [class~=not-rte] *) fait recalculer tout le document à chaque changement de classe du <body> (≈ 1 070 éléments,
     17-20 ms en CPU ×4) ; un attribut data-* ne recalcule que les éléments visés par nos règles. */
  function unguard(){ var b=document.body; if(b && b.hasAttribute('data-bgp-wait')){ b.removeAttribute('data-bgp-wait'); b.removeAttribute('data-bgp-wait-meta'); } }
  function run(){
    try{
      buildMeta();
      hideBack();
      addDescLabel();
      shortenPills();
      wireAutre();
      if(buildSummary() && !document.body.hasAttribute('data-bgcom-polished')) document.body.setAttribute('data-bgcom-polished','');
      syncMetaRef();
      syncPro();
      patchAutocomplete();
      observeVariant();
      subscribeVariant();
    }catch(e){}
    finally{ unguard(); }
  }
  /* 04/10/2026 (vitesse r2, r4 : en defer, le premier passage a lieu quand toute la page est analysée, juste avant DOMContentLoaded) :
     one pass right away, one at DOMContentLoaded if still loading (full page: origin, description, theme pubsub) and one
     at load; then only on change (MutationObserver on the buy box, variant change, form change). The reruns at 400 / 1000 /
     2000 ms are gone: they ran while the page was still parsing, each one a 60-110 ms long task with a forced layout. */
  run();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
  if(document.readyState!=='complete') window.addEventListener('load',run);
})();
